var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.04001V0.0400085H14V2.04001H17.0066C17.5552 2.04001 18 2.48496 18 3.03341V19.0466C18 19.5952 17.5551 20.04 17.0066 20.04H0.9934C0.44476 20.04 0 19.5951 0 19.0466V3.03341C0 2.48477 0.44495 2.04001 0.9934 2.04001H4ZM4 4.04001H2V18.04H16V4.04001H14V6.04001H4V4.04001ZM6 2.04001V4.04001H12V2.04001H6Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderManagementIcon);
export default __webpack_public_path__ + "static/media/order-management-icon.e858da076b95a0e79a9d2f9bb8b82079.svg";
export { ForwardRef as ReactComponent };